import axios from "axios";
import React, { useState } from "react";
import { string } from "prop-types";
import CareSolvedOption from "components/care_solved/CareSolvedOption";
import CareSolvedQueryForm from "components/care_solved/CareSolvedQueryForm";
import SegmentClient from "clients/SegmentClient";
import questionIcon from "icons/send-a-message.png";

function CareSolvedQuery({ email, membershipNumber }) {
  const [formOpen, toggleForm] = useState(false);
  const [formValues, updateFormValues] = useState({
    email,
    membership_number: membershipNumber,
    full_name: "",
    phone: "",
    message: ""
  });
  const [formState, updateFormState] = useState(null);

  function updateValues(e) {
    updateFormValues({ ...formValues, [e.target.id]: e.target.value });
  }

  function openContactForm() {
    SegmentClient.trackEvent({
      event: "vitality send message click",
      eventCategory: "pre-user activation",
      eventAction: "vitality send message click",
      eventLabel: "click"
    });

    toggleForm(true);
  }

  async function submitQuery(e) {
    e.preventDefault();
    try {
      if (window.ZAPIER_VITALITY_URL) {
        await axios.post(
          window.ZAPIER_VITALITY_URL,
          JSON.stringify(formValues)
        );
      }
      updateFormState("success");

      SegmentClient.trackEvent({
        event: "vitality message submitted",
        eventCategory: "pre-user activation",
        eventAction: "vitality message submitted",
        eventLabel: "click"
      });

      setTimeout(() => {
        toggleForm(false);
      }, 2000);
    } catch (err) {
      console.log("error = ", err);
      updateFormState("error");
    }
  }

  return (
    <>
      {formOpen && (
        <CareSolvedQueryForm
          formState={formState}
          formValues={formValues}
          submitQuery={submitQuery}
          toggleOpen={toggleForm}
          updateValues={updateValues}
        />
      )}
      <CareSolvedOption
        buttonAction={openContactForm}
        buttonLabel="Send Message"
        description="Any care questions, just leave a message and a care expert will respond."
        icon={questionIcon}
        name="Ask us a question"
      />
    </>
  );
}

CareSolvedQuery.propTypes = {
  email: string.isRequired,
  membershipNumber: string.isRequired
};

export default CareSolvedQuery;
